// extracted by mini-css-extract-plugin
module.exports = {"cardContainer":"ListAddress_cardContainer__3hOz3","break":"ListAddress_break__dTEaB","childCard":"ListAddress_childCard__mLO7x","title":"ListAddress_title__29UwJ"};